import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store.js";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";
import VuetifyDialogPromise from "vuetify-dialog-promise";
const moment = require("moment");
import LevamSupportWindow from 'levam-support-window';
Vue.use(LevamSupportWindow);

Vue.use(require("vue-moment"), {
  moment,
});
Vue.use(VuetifyDialog, {
  context: {
    vuetify,
  },
});

Vue.config.productionTip = false;

Vue.use( VuetifyDialogPromise, {
  snackbarParent: "app",
  locale : i18n.locale,
  snackbarX : "right",
  snackbarY : "bottom"
} );


new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
